/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { PresentationFilter } from '../../../../types/PresentationFilter';
import { PresentationSort } from '../../../../types/PresentationSort';

export const PresentationSearchRequest: core.serialization.Schema<
    serializers.PresentationSearchRequest.Raw,
    Truvity.PresentationSearchRequest
> = core.serialization.object({
    filter: core.serialization.list(PresentationFilter).optional(),
    sort: core.serialization.list(PresentationSort).optional(),
});

export declare namespace PresentationSearchRequest {
    export interface Raw {
        filter?: PresentationFilter.Raw[] | null;
        sort?: PresentationSort.Raw[] | null;
    }
}
